var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RoleSelector"},[_c('el-select',{attrs:{"value":_vm.valueUse,"placeholder":"请选择角色"},on:{"input":_vm.change}},[(_vm.isFilter)?_c('el-option',{attrs:{"label":"所有角色","value":0}}):_vm._e(),_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }